import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="categories-navigation"
export default class extends Controller {
  static targets = [
    "container",
    "nestedCategories",
    "toggleText",
    "toggleIcon",
  ];

  connect() {
    // Controller is ready
  }

  toggle() {
    const isExpanded =
      !this.nestedCategoriesTarget.classList.contains("hidden");

    if (isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  collapse() {
    this.containerTarget.classList.remove("max-h-80");
    this.containerTarget.classList.add("max-h-16");
    this.nestedCategoriesTarget.classList.add("hidden");
    this.toggleTextTarget.textContent = "Show subcategories";
    this.toggleIconTarget.classList.remove("rotate-180");
  }

  expand() {
    this.containerTarget.classList.remove("max-h-16");
    this.containerTarget.classList.add("max-h-80");
    this.nestedCategoriesTarget.classList.remove("hidden");
    this.toggleTextTarget.textContent = "Hide subcategories";
    this.toggleIconTarget.classList.add("rotate-180");
  }
}
